import { ref, reactive, defineComponent, watch } from '@vue/composition-api';
import { _common_data } from './common_data';
import mainMenu from "@c/mainMenu.vue";
export default defineComponent({
    name: "common",
    components: { mainMenu: mainMenu },
    setup: function () {
        var data = reactive(_common_data);
        var menuItemClass = function (item, num) {
            return (num === 6 && app.pageId === 1) || (num === 5 && app.pageId === 2)
                || (num === 7 && app.pageId === 3)
                ? 'current' : '';
        };
        var loaded = ref(false);
        watch(function () { return app.loaded; }, function (l) {
            /*if (loaded) {
              console.log('app loaded')
            }*/
            loaded.value = l;
        });
        return {
            data: data,
            loaded: loaded,
            menuItemClass: menuItemClass
        };
    }
});
